'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgActionZapDetails = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M20 8V6.59L15.41 2H4v20h16V10h-2v10H6V4h8v4h6Z" }),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "m10.75 18.858 4.809-5.729H13.25V9.067l-4.808 5.729h2.308v4.062Z" })
);

module.exports = SvgActionZapDetails;
//# sourceMappingURL=ActionZapDetails.cjs.js.map
